const Manager = () => {
    return (
        <>
            Manager
        </>
    )

};

export default Manager;